export const backups = {
  taskType: [
    {
      value: 0,
      label: '导出'
    }, {
      value: 1,
      label: '导入'
    }
  ]
}

export default {
  backups
}



// WEBPACK FOOTER //
// ./src/data/backups.js